export default __webpack_public_path__ + "static/media/boxtype12.6cc569ef.JPG";